module.exports = __webpack_public_path__ + "664e79dc270266cc5155d061906302cc.jpg";